import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-239be6f7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "slide-list-header" }
const _hoisted_2 = {
  key: 0,
  class: "mini-case-list"
}
const _hoisted_3 = { class: "item" }
const _hoisted_4 = { class: "item" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = {
  key: 1,
  class: "viewer"
}
const _hoisted_7 = { class: "slide-list-container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SlidePreview = _resolveComponent("SlidePreview")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_i_button = _resolveComponent("i-button")!
  const _component_i_dialog = _resolveComponent("i-dialog")!

  return (_openBlock(), _createElementBlock("div", {
    id: "slides_panel",
    class: _normalizeClass({ pinned: _ctx.isSlidePinned(), full: _ctx.fullPageView, blocked: _ctx.errorModal })
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isSlidePinned())
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, [
              _createTextVNode(_toDisplayString(_ctx.t('cases_list.date')) + ": ", 1),
              _createElementVNode("strong", null, _toDisplayString(_ctx.activeCase.date), 1)
            ]),
            _createElementVNode("span", _hoisted_4, [
              _createTextVNode(_toDisplayString(_ctx.t('cases_list.number_of_slides')) + ": ", 1),
              _createElementVNode("strong", null, _toDisplayString(_ctx.activeCase.numberOfSlides), 1)
            ]),
            _createElementVNode("span", _hoisted_5, [
              _createTextVNode(_toDisplayString(_ctx.t('cases_list.assigned_to')) + ": ", 1),
              _createElementVNode("strong", null, _toDisplayString(_ctx.activeCase.assignedTo), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.t('slides.title')) + " (" + _toDisplayString(_ctx.activeCase.numberOfSlides) + ")", 1)
          ]))
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide) => {
        return (_openBlock(), _createBlock(_component_SlidePreview, {
          key: slide.slideId,
          slide: slide,
          theme: _ctx.currentSlide.id === slide.slideId ? 'dark' : 'light',
          onSelectFromSlide: _ctx.navigateToSlide
        }, null, 8, ["slide", "theme", "onSelectFromSlide"]))
      }), 128))
    ]),
    (_ctx.errorModal)
      ? (_openBlock(), _createBlock(_component_i_dialog, {
          key: 0,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.errorModal = false)),
          title: _ctx.t(`slides.slides_error_modal.header`),
          type: _ctx.modalTypes.ERROR
        }, {
          body: _withCtx(() => [
            _createVNode(_component_i18n_t, {
              tag: "p",
              keypath: "slides.slides_error_modal.body"
            }, {
              newline: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          footer: _withCtx(() => [
            _createVNode(_component_i_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.errorModal = false)),
              text: _ctx.t('modal.action.ok'),
              themeColor: "primary"
            }, null, 8, ["text"])
          ]),
          _: 1
        }, 8, ["title", "type"]))
      : _createCommentVNode("", true)
  ], 2))
}